import React, { useState, useEffect } from 'react';
import { LocaleProviderCtx } from '@airasia-common/libraries/i18n/LocaleProvider';
import { bool, object, string } from 'prop-types';
import PhoenixTheme from '@airasia/phoenix-components/components/Theme';
import PopupMessage from '@airasia/phoenix-components/components/PopupMessage';
import useWindowSize from '../../utils/windowSize';

const FallbackCurrencyMessage = ({
  selectedCurrency,
  currency,
  enableErrorRevamp,
}) => {
  const polyglot = React.useContext(LocaleProviderCtx);
  const [isShowMessage, setIsShowMessage] = useState(false);
  const { isMobileView } = useWindowSize();
  const AUTO_HIDE_TIMER = 5000;

  useEffect(() => {
    if (selectedCurrency) {
      const isFallback = selectedCurrency.value !== currency;
      setIsShowMessage(isFallback);
    }
  }, [selectedCurrency, currency]);

  return (
    <PhoenixTheme>
      <PopupMessage
        isShow={isShowMessage}
        zIndex={20}
        message={
          enableErrorRevamp
            ? polyglot.t('statusCode.currencyConversionFail')
            : polyglot.t('common.currencyNotSupported', {
                currency,
              })
        }
        autoHideDuration={AUTO_HIDE_TIMER}
        onClose={() => setIsShowMessage(false)}
        isMobile={isMobileView}
      />
    </PhoenixTheme>
  );
};

FallbackCurrencyMessage.propTypes = {
  currency: string.isRequired,
  selectedCurrency: object.isRequired,
  enableErrorRevamp: bool,
};

export default FallbackCurrencyMessage;
